/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Minimum_Booking_DurationInputs */

const en_admin_resource_form_minimum_booking_duration = /** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Booking Duration`)
};

const de_admin_resource_form_minimum_booking_duration = /** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Buchungsdauer`)
};

const es_admin_resource_form_minimum_booking_duration = /** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración mín. de la reserva`)
};

const fr_admin_resource_form_minimum_booking_duration = /** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée min. de réservation`)
};

const nl_admin_resource_form_minimum_booking_duration = /** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. reserveringsduur`)
};

/** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */
const it_admin_resource_form_minimum_booking_duration = en_admin_resource_form_minimum_booking_duration;

/** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */
const pt_br2_admin_resource_form_minimum_booking_duration = en_admin_resource_form_minimum_booking_duration;

/** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */
const pl_admin_resource_form_minimum_booking_duration = en_admin_resource_form_minimum_booking_duration;

/** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */
const hu_admin_resource_form_minimum_booking_duration = en_admin_resource_form_minimum_booking_duration;

/** @type {(inputs: Admin_Resource_Form_Minimum_Booking_DurationInputs) => LocalizedString} */
const ro_admin_resource_form_minimum_booking_duration = en_admin_resource_form_minimum_booking_duration;

/**
* | output |
* | --- |
* | "Min. Booking Duration" |
*
* @param {Admin_Resource_Form_Minimum_Booking_DurationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_minimum_booking_duration = /** @type {((inputs?: Admin_Resource_Form_Minimum_Booking_DurationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Minimum_Booking_DurationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "de") return de_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "es") return es_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "fr") return fr_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "nl") return nl_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "it") return it_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "pl") return pl_admin_resource_form_minimum_booking_duration(inputs)
	if (locale === "hu") return hu_admin_resource_form_minimum_booking_duration(inputs)
	return ro_admin_resource_form_minimum_booking_duration(inputs)
});
export { admin_resource_form_minimum_booking_duration as "admin.resource_form.minimum_booking_duration" }